/**
 * Class for image model.
 */
export default function ImageModel(dpi, res)
{
    // shared sprites
    this.uiJSON = require(`../../sprite/buttons${res}.json`);
    this.uiURL = require(`../../sprite/buttons${res}.png`);

    // shared images
    this.buttonSecondaryNormalImage = require(`../../img/btn/button-secondary-normal${res}.png`);
    this.buttonSecondaryHoverImage = require(`../../img/btn/button-secondary-hover${res}.png`);

    this.preload = [
        this.buttonSecondaryNormalImage,
        this.buttonSecondaryHoverImage,
        this.uiJSON,
    ];

    return this;
}




// WEBPACK FOOTER //
// ./babel/model/image-model.js